// extracted by mini-css-extract-plugin
export default {"linkStyleCopy":"Q4-z"};